var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noteDeFrais && _vm.noteDeFrais.pdfFile)?_c('a',{staticClass:"btn btn-xs btn-default",attrs:{"href":_vm.noteDeFrais.pdfFile.path,"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }